import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error";
import DatePicker from "core/gd-form/form-element/datepicker/datepicker-new";

export default function FormStartEndSelector(props) {
    return (
        <div className="row planning">
            <div className="label">Planning</div>
            <div className="element">
                <DatePicker form={props.form}
                            name="startDate"
                            placeholderText="Start date"
                            inline={true} />
                <div className="s-e">-</div>
                <DatePicker form={props.form}
                            name="endDate"
                            placeholderText="End date"
                            inline={true} />

                <FormError form={props.form} name="startDate" />
                <FormError form={props.form} name="endDate" />
            </div>
        </div>
    )
}

FormStartEndSelector.propTypes = {
    form: PropTypes.object
}